import React from "react";
import { useIntl } from "react-intl";
import { Modal } from "@jelly/ui";

import styles from "./Modals.module.scss";
import { messages } from "../Delivery.messages";
import { useBlocks, useUi } from "@jelly/lesson";
import * as appConfig from "appConfig";
import { nl2p } from "@src/utils/nl2p";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

type ModalProps = Omit<React.ComponentProps<typeof Modal>, "children">;

export const ExportModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P5_M_Export_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P5_M_Export_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page05/modal_export_1.png`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const BussesModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P5_M_Busses_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P5_M_Busses_Description))}</div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page05/modal_busses_1.png`} />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page05/modal_busses_2.png`} />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const RoutingModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P5_M_Routing_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P5_M_Routing_Description))}</div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page05/modal_route_1.png`} />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page05/modal_route_2.png`} />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const DolbyModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P5_M_Dolby_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P5_M_Dolby_Description))}</div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page05/modal_dolby_1.png`} />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page05/modal_dolby_2.png`} />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const AdmModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P5_M_Adm_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P5_M_Adm_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page05/modal_adm_1.png`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};
